import { fetchEndpoint } from '../server/network';

// 虚拟电子卡列表
export const vcardList =
(page, per_page, status) =>
fetchEndpoint(
  '/v2/ecapi.vcard.list',
  'POST',
  {
    "page": page,  // 当前第几页
    "per_page": per_page,  // 每页多少
		"status": status,  // 按红包状态筛选
		"after":0,
  }
)

// 获得虚拟电子卡详情
export const vcardGet =
(id) =>
fetchEndpoint(
  '/v2/ecapi.vcard.get',
  'POST',
  {
    "id": id,  // 虚拟卡ID
  }
)

// 搜索可用优惠列表
export const vcardAvailable =
(page, per_page, shop, total_price) =>
fetchEndpoint(
  '/v2/ecapi.cashgift.available',
  'POST',
  {
    "page": page,  // 当前第几页
    "per_page": per_page,  // 每页多少
    "shop": shop,  // 店铺ID
		"total_price": total_price,  // 总价
		"after":0,
  }
)




// WEBPACK FOOTER //
// ./src/api/vcard.js